/** The `/custom-domain-test` link's credential, which analytics must never capture. */
export const CUSTOM_DOMAIN_TEST_TOKEN_PARAM = 'token';

/** `theme.ts`'s `filled` resolver draws a hairline that `@blockit/ui`'s `default` variant has no equivalent for. */
export const BUTTON_HAIRLINE_CLASS = 'border-black';

/** Mantine's `default` button is `--input`-bordered, a step darker than `@blockit/ui`'s `outline`. */
export const OUTLINE_HAIRLINE_CLASS = 'border-input';

/** `@blockit/ui`'s `destructive` variant is a tint, so a solid red button has to paint itself. */
export const DESTRUCTIVE_FILLED_CLASS = 'bg-destructive text-destructive-foreground hover:bg-destructive/80';

/** Mantine's `variant='light'` green: a tint of the brand ramp, not the flat `tone='green'` pill. */
export const GREEN_TINT_CLASS = 'bg-green-light/45 dark:bg-green-dark/25';
